import type { TimelineNode } from "@/mocks/events";

export default function EventTimeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <ol className="relative mt-6 flex flex-col gap-6 border-l-2 border-dashed border-background-300 pl-6">
      {nodes.map((node, index) => (
        <li key={`${node.date}-${node.title}`} className="relative">
          <span
            className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 ${
              index === nodes.length - 1 ? "bg-primary-500" : "bg-secondary-400"
            }`}
          ></span>
          <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className="rounded-md bg-background-50 px-2.5 py-0.5 font-label text-xs font-medium text-primary-700">
                第 {index + 1} 步 · {node.date}
              </span>
              <h4 className="font-heading text-sm font-bold text-foreground-950 md:text-base">{node.title}</h4>
            </div>
            <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{node.content}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}